import { DimensionsWithChildren } from "@/store/dimensions/utils/types/common";

export const dimensionsDataGridNameValueGetter = (
  data: DimensionsWithChildren | undefined,
): string => {
  if (!data) {
    return "";
  }

  const filterTreeString = data?.categories
    ?.map((item) => JSON.stringify(item.filters?.filter_tree ?? {}))
    .join("");
  const categoryNames = data?.categories
    ?.map((item) => item?.name ?? "")
    .join("");

  return `${data?.name}-${data?.categories?.length}-${filterTreeString}-${categoryNames}`;
};
